import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { authLogin, authLogout, authSettingsSetup } from "../store/authSlice";
import { postData } from "../services/api";
import useTokenExpirationChecker from "../hooks/useTokenExpirationChecker";

const ProtectedRoute = (props) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [auth, setAuth] = useState(false);
  let token_ = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");
  const accessRole = ["master-admin", ...props.getAccess];
  const auth_user = useSelector((state) => state.auth?.user);

  useTokenExpirationChecker();

  useEffect(() => {
    async function fetchData() {
      const settingsData = await postData("setting/details", {}, token_);
      const userData = await postData("verify-token", {}, token_);
      if (userData?.status === 200 && token_) {
        if (userData?.data && userData?.data?._id) {
          setAuth(true);
          dispatch(authLogin(userData?.data));
          dispatch(authSettingsSetup(settingsData?.data));
        } else {
          setAuth(false);
          dispatch(authLogout());
          localStorage.removeItem("accessToken");
          navigate("/signin");
        }
        return;
      } else {
        setAuth(false);
        dispatch(authLogout());
        localStorage.removeItem("accessToken");
        navigate("/signin");
        return;
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, token_, navigate]);

  useEffect(() => {
    async function checkPath() {
      let checkRole = accessRole.filter((item) => item === role);
      if (checkRole && checkRole.length === 0) {
        if (
          role === "master-admin" ||
          role === "basic-administrator" ||
          role === "sales-admin" ||
          role === "sales-staff" ||
          role === "content-manager"
        ) {
          return navigate("/dashboard-statistics");
        } else if (role === "customer-user") {
          return navigate("/profiles");
        } else if (role === "customer-boardmember") {
          if (
            auth_user?.survey_access?.find(
              (it) => it === "send-information-request"
            )
          ) {
            return navigate("/boardroom");
          } else if (
            auth_user?.survey_access?.find(
              (it) => it === "send-board-strength-survey"
            )
          ) {
            return navigate("/perspective-board-member");
          } else {
            return navigate("/perspective-board-member");
          }
        } else if (role === "customer-executive") {
          return navigate("/add-executive");
        } else {
          return navigate("/dashboard");
        }
      }
    }
    checkPath();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, window.location.pathname, props.getAccess]);

  return <>{auth && props.children}</>;
};

export default ProtectedRoute;
